// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  typeOfEnv: 'DEV',
  production: false,
  configType: true,
  topAlertSetting: true,
  logoUrl: "https://www.dataunveil.com/assets/img/logo.png",
  apiBaseUrl: "https://dev-api.scraii.com",
  // Per-client API base URL overrides, keyed by client_key.
  // Applied automatically once a client is selected (see ApiService.setClientApiBaseUrl).
  // An empty string / missing key falls back to the default apiBaseUrl above.
  clientApiBaseUrls: {
    1001: 'https://dev-api.scraii.com',
    2001: 'https://dev-api.scraii.com',
    3001: 'https://dev-api.scraii.com',
    4001: 'https://dev-api.scraii.com',
    9001: 'https://dev-api.scraii.com',
  } as { [clientKey: string]: string },
  redirectUri: 'https://dev.scraii.com',
  // redirectUri: "http://localhost:4200",
  // Cognito Hosted UI domain for Okta SSO (e.g. 'myapp.auth.us-east-2.amazoncognito.com')
  cognitoDomain: 'dataunveil.auth.us-east-2.amazoncognito.com',
  ssoProviderName: 'DU-SSO-SCRAII',
  widgetConfigEndPoint: "kpi/get-widget-details-by-id",
  apiListEndPoint: "kpi/get-widget-details",
  apiColumnListEndPoint: "kpi/get-list-of-value",
  getListOfWork: "kpi/get-list-of-work",
  getWorkDetails: "kpi/get-work-details-by-id",
  addNewWorkList: "kpi/insert-work-layout",
  infoIconText: "FRMPortal/get-info-text",
  AMPLIFY: {
    region: "us-east-2",
    userPoolId: "us-east-2_IBRNnm00y",
    authenticationFlowType: "USER_PASSWORD_AUTH",
    userPoolWebClientId: "2oubd6j8aae431u2disld0fnge",
  },
  pageAddEditEndPoint: "kpi/insert-page-details",
  pageListEndPoint: "kpi/get-page-list",
  ConfigTypeEndPoint: "kpi/get-config-type",
  EnvironmentEndPoint: "kpi/get-environment-type",

  getUserInfo: "api/get-user-info",
  // Returns the primary / secondary dm_schema mapping for the multi-schema
  // toggle (response: [{ schema_type, dm_schema }, ...]).
  getSchemaData: "frm-glks/get-schema-data",

  patientListFRM: "FRMPortal/get-patient-list",
  getCycleData: "kpi/get-execution-details",
  getBrandDate: "KPI/get-brand-date",
  serverSideExcelExport: "export/export-to-excel",
  serverSideCSVExport: "export/export-to-csv",
  getExportUserManual: "export/get-help-url",
  getPhiUserAccess : "api/has-phi-access",

  MixPanelToken: "7ed5424106e8cf5d9cf62314f2b2ef55",
  MixPanelTrack: true,
  MixPanelDBTrack: true,
  cryptoJSKey: "70928978935b5b55ab14a83cbb",
  cryptoJSIV: "5b5b55ab14a83cbb7092897893",
  clientId: "1d5fa526-092f-480f-a900-617a80ada1c0",
  aiActionSqlEndPoint: "https://5obzletvnutjfsugnme5vwinyi0kbkmu.lambda-url.us-east-2.on.aws",
  aiChatEndPoint: "https://kcqlu3l811.execute-api.us-east-2.amazonaws.com/stage",
  aiChatbotEndPoint: "https://kcqlu3l811.execute-api.us-east-2.amazonaws.com/stage/ai-chatbot",
  aiAsyncInvokeEndPoint: "https://kcqlu3l811.execute-api.us-east-2.amazonaws.com/jobidcreator/asyncinvoke",
  aiAsyncPollEndPoint: "https://kcqlu3l811.execute-api.us-east-2.amazonaws.com/jobidcreator/async",
  aiExecuteSqlEndPoint: "https://kcqlu3l811.execute-api.us-east-2.amazonaws.com/execute-sql/execute-sql",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
